<template>
    <div>
        <div class="show" data-toggle="modal" :data-target="'#view-'+this.id" ><span class="material-icons">visibility</span></div>
        <div class="modal" tabindex="-1"  :id="'view-'+this.id" ref="vuemodal" :key="'view-'+this.id">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Priekšmeta kartīte</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modalNavigation">
                        <div class="navigationButton prev" @click="openPrevItemModal()">
                            <span class="material-icons">chevron_left</span>
                        </div>
                        <div class="navigationButton next" @click="openNextItemModal()">
                            <span class="material-icons next">chevron_right</span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="modalMenu">
                            <span class="modalMenuItem" @click="changeStep('main')" :class="{'active': step === 'main'}">Pamatinformācija</span>
                            <span class="modalMenuItem" @click="changeStep('scientific')" :class="{'active': step === 'scientific'}">Zinātniskais apraksts</span>
                            <span class="modalMenuItem" @click="changeStep('images')" :class="{'active': step === 'images'}">Attēli un faili</span>
                            <span class="modalMenuItem" @click="changeStep('events')" :class="{'active': step === 'events'}">Priekšmeta vēsture</span>
                        </div>
                        <div v-if="step=='main'">
                            <div class="row">
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="cipher">Šifrs</label>
                                        <input type="text"  id="cipher" :value="cipher" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="item_number">Numurs</label>
                                        <input type="text" id="item_number" :value="item_number" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="item_subnumber">Apakšnumurs</label>
                                        <input type="text" id="item_subnumber" :value="item_subnumber" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="act_number">Akta numurs</label>
                                        <input type="text" id="act_number" v-model="act_number" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4" v-if="hasPermission(user,'krajuma_darbinieks')">
                                    <div class="form-group">
                                        <label for="acquire_from">Nodevējs</label>
                                        <input type="text" id="acquire_from" :value="acquire_from" class="form-control" disabled>
                                    </div>
                                </div>

<!--                                <div class="col-2">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="photo_number">Foto numurs</label>-->
<!--                                        <input type="text" id="photo_number" :value="photo_number" class="form-control" disabled>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-2">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="item_count">Skaits</label>-->
<!--                                        <input type="text" id="item_count" :value="item_count" class="form-control" disabled>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="item_title">Nosaukums</label>
                                        <input type="text" id="item_title" :value="item_title" class="form-control" disabled>

                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="item_collection">Kolekcija</label>
                                        <input type="text" id="item_collection" :value="item_collection" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="scientific_theme">Krājuma komplektēšanas tēma</label>
                                        <input type="text" id="scientific_theme" :value="scientific_theme" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="transfer_type">Ieguve</label>
                                        <input type="text" id="transfer_type" :value="transfer_type" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="author">Autors</label>
                                        <input type="text" id="author" :value="author" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="item_copyright_id">Autortiesības</label>
                                        <select name="item_copyright_id" id="item_copyright_id" v-model="item_copyright_id" class="form-control" disabled>
                                            <option :value="null">Nav norādīts</option>
                                            <option :value="copyright.id" v-for="copyright in copyrights" :key="'copy-'+copyright.id">{{copyright.status}} ({{copyright.reason}})</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="location_of_manufacture">Izgatavošanas vieta</label>
                                        <input type="text" id="location_of_manufacture" :value="location_of_manufacture" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="time_of_manufacture">Izgatavošanas laiks</label>
                                        <input type="text" id="time_of_manufacture" :value="time_of_manufacture" class="form-control" disabled>
                                    </div>
                                </div>
<!--                                <div class="col-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="content_date">Satura datējums</label>-->
<!--                                        <input type="text" id="content_date" :value="content_date" class="form-control" disabled>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="size">Izmērs</label>
                                        <input type="text" id="size" :value="size" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="material">Materiāls</label>
                                        <input type="text" id="material" :value="material" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="placement">Novietojums</label>
                                        <input type="text" id="placement" :value="placement" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-3" v-if="hasPermission(user,'krajuma_darbinieks')">
                                    <div class="form-group">
                                        <label for="price_eur">Cena (EUR)</label>
                                        <input type="text" id="price_eur" :value="price_eur" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-3" v-if="hasPermission(user,'krajuma_darbinieks')">
                                    <div class="form-group">
                                        <label for="purchase">Iepirkums</label>
                                        <select name="purchase" id="purchase" :value="purchase" class="form-control" disabled>
                                            <option value="-1">Jā</option>
                                            <option value="0">Nē</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="item_heading">Priekšmeta virsraksts jeb nosaukums</label>
                                        <input type="text" id="item_heading" :value="item_heading" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="description">Apraksts</label>
                                        <textarea rows="5" name="description" id="description" class="form-control" disabled>{{description}}</textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="notes">Saglabātība</label>
                                        <textarea rows="2" name="notes" id="notes" class="form-control" disabled>{{notes}}</textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='scientific'">
                            <div class="scientificDescriptions">
                                <div v-if="scientific_description.length > 0" class="descriptionWrapper" v-for="description in scientific_description" :key="description.id">
                                    <div class="description">
                                        <div class="form-group">
                                            <label for="status">Apraksts</label>
                                            <textarea  rows="5" class="form-control" v-model="description.description" :disabled="user.id != description.user_id">{{description.description}}</textarea>
                                        </div>
                                        <div class="form-group">
                                            <label for="status">Ieraksta autors</label>
                                            <input type="text" v-if="description.author" class="form-control" disabled :value="description.author.firstname+' '+description.author.lastname">
                                            <input type="text" v-else class="form-control" disabled value="Norādīts aprakstā">
                                        </div>
                                    </div>
                                    <div class="meta">
                                        <div class="form-group status">
                                            <label for="status">Status</label>
                                            <select :value="description.status" class="form-control" disabled>
                                                <option value="accepted">Apstiprināts</option>
                                                <option value="pending">Gaida apstiprināšanu</option>
                                            </select>
                                        </div>
                                        <div class="form-group created_at">
                                            <label for="status">Izveidots</label>
                                            <input type="text" :value="normalDateTime(description.created_at)" class="form-control" disabled>
                                        </div>
                                        <div class="form-group updated_at">
                                            <label for="status">Atjaunots</label>
                                            <input type="text" :value="normalDateTime(description.updated_at)" class="form-control" disabled>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-danger" @click="deleteDescription(description.id)" v-if="hasPermission(user,'krajuma_darbinieks') || user.id==description.user_id">Dzēst</button>
                                            <button class="btn btn-success" @click="saveDescription(description.id)" v-if="hasPermission(user,'krajuma_darbinieks') || user.id==description.user_id">Saglabāt</button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="alert alert-light">Priekšmetam nav pievienots neviens zinātniskais apraksts.</div>
                                <hr>
                                <div class="actions text-right">
                                    <button class="btn btn-primary" @click="createNewDescription()" :key="item.id">Pievienot jaunu</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='images'">
                                    <CoolLightBox
                                        :items="imageListForLightbox"
                                        :index="index"
                                        srcName="src"
                                        @close="index = null">
                                    </CoolLightBox>
                                    <div class="subsection">
                                        <div class="title">
                                            Attēli
                                        </div>
                                    </div>
                                    <div class="gallery">
                                        <div v-if="item_images.length > 0" v-for="(image, imageIndex) in item_images" :key="image.id" class="galleryItem">
                                            <div class="image">
                                                <img @click="index = imageIndex" :src="'/public/image/thumb/'+image.file_name">
                                            </div>
                                            <div class="description">
                                                <label for="description">Piezīmes</label>
                                                <textarea name="description" id="description" rows="2" class="form-control" :value="image.notes" disabled>{{image.notes}}</textarea>
                                            </div>
                                            <div class="print">
                                                <label for="print">Drukāt</label>
                                                <select name="print" id="print" :value="image.print" class="form-control" disabled>
                                                    <option value="-1">Jā</option>
                                                    <option value="0">nē</option>
                                                </select>
                                            </div>
                                            <div class="visibility">
                                                <label for="public">Publisks</label>
                                                <select name="public" id="public" :value="image.public" class="form-control" disabled>
                                                    <option value="0">Jā</option>
                                                    <option value="-1">nē</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-else class="alert alert-light">Priekšmetam nav pievienots neviens attēls.</div>
                                    </div>
                                    <div class="subsection">
                                        <div class="title">
                                            Saistītie faili
                                        </div>
                                    </div>
                                    <div  class="filesList">
                                        <div class="file" v-for="file in item_files" :key="file.id">
                                            <div class="fileName">{{file.file_name}}</div>
                                            <div class="actions">
                                                <a :href="'/dashboard/api/items/'+item.id+'/fileDownload/'+file.id" class="download"> <span class="material-icons">download</span></a>
                                            </div>
                                        </div>
                                    </div>

                        </div>
                        <div v-if="step=='events'">
                            <div class="subsection">
                                <div class="title">
                                    Manuāli pievienotā priekšmeta vēsture
                                </div>
                            </div>
                            <div class="itemEvents">
                                <table class="table">
                                    <thead class="bg-light">
                                    <tr>
                                        <td>Datums no</td>
                                        <td>Datums līdz</td>
                                        <td>Nosaukums</td>
                                        <td>Apraksts</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr class="eventWrapper" v-for="event in events_list" :key="event.id">
                                        <td>
                                            <div class="form-group">
                                                <input type="text" :value="normalDate(event.start_date)" disabled>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group">
                                                <input type="text" :value="normalDate(event.end_date)" disabled>
                                            </div>
                                        </td>
                                        <td><input type="text" class="form-control" :value="event.event_name" disabled></td>
                                        <td style="width:400px">
                                            <textarea type="text" class="form-control" disabled>{{event.event_description}}</textarea>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <item-events-component :id="item.id" :show_link="false"></item-events-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.modalNavigation{
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    position:absolute;
    pointer-events: none;
    .navigationButton
    {
        pointer-events:auto;
        background-color:$blue;
        color:#fff;
        width:50px;
        height: 50px;
        border-radius:100%;
        display:flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0px 1px 20px rgba(255, 255, 255, 0.4);
        &.prev{
            margin-left:-60px;
        }
        &.next{
            margin-left:auto;
            margin-right:-60px;
        }
    }
}
.subsection
{
    width:100%;
    display:flex;
    align-items: center;
    padding-bottom:5px;
    padding-top:10px;
    border-bottom:solid 5px #eee;
    margin-bottom:15px;
    .title{
        font-size:18px;
        font-weight:bold;
    }
    .actions{
        margin-left:auto;
    }
}
.scientificDescriptions{
    .descriptionWrapper{
        margin-bottom:20px;
        padding-bottom:15px;
        border-bottom:solid 5px #eee;
        display:flex;
        align-items: flex-start;
        justify-items: center;
        .description{
            flex-grow:1;
        }
        .meta{
            padding-left:30px;
            width:250px;
        }
    }
}
.show{
    display:flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.modal-body{
    position:relative;
}
.gallery{
    display:flex;
    flex-wrap:wrap;
    .galleryItem{
        cursor: pointer;
        padding: 10px;
        width:100%;
        display:flex;
        img{
            max-width:100%;
            height:auto;
        }
        .image{
            position: relative;
            width:25%;
            max-width:200px;
        }
        .description{
            padding:0 20px;
            width:25%;
        }
        .visibility, .print{
            padding:0 20px;
            width:25%;
        }
        .delete{
            position:absolute;
            top:10px;
            right:10px;
            width:30px;
            height:30px;
            background:rgba(255,255,255,.75);
            cursor: pointer;
            border-radius: 100%;
            display:flex;
            align-items: center;
            justify-content: center;

        }
    }
}

</style>

<script>

export default{
    props:['user','item','transfer_types', 'item_titles','item_collections','scientific_themes','ciphers','copyrights'],
    mounted()
    {
        this.populateData();
        var that = this;
        EventBus.$on('page_updated',() =>
        {
            console.log("Should populate data");
            that.populateData();
        });

    },
    data()
    {
        return {
            id:"",
            cipher:"",
            item_number:"",
            item_subnumber:"",
            photo_number:"",
            transfer_type_id:"",
            acquire_from:"",
            collection_old:"",
            title_old:"",
            author:"",
            location_of_manufacture:"",
            time_of_manufacture:"",
            content_date:"",
            old_description:"",
            description:"",
            item_heading:"",
            notes:"",
            placement:"",
            size:"",
            material:"",
            price_eur:"",
            price_ls:"",
            item_count:"",
            entry_date:"",
            entry_time:"",
            act_number:"",
            act_id:"",
            post_processing:"",
            purchase:"",
            date_of_migration_to_nmkk:"",
            item_value:"",
            evaluation_report:"",
            existence:"",
            acquire_type_id:"",
            collection_id:"",
            title_id:"",
            scientific_theme_id:"",

            //New fields
            item_title:"",
            item_collection:"",
            scientific_theme:"",
            transfer_type:"",
            item_copyright_id:"",


            step:"main",
            loading:false,
            index:null,

            item_images:[],
            item_files:[],
            item_image_sort:[],

            scientific_description:[],
            item_events:[],

            drag: false,
            headers: {
                "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
            },
        }
    },
    methods: {
        hasPermission(user,permission)
        {

            return user.allpermissions.some(function(p) {
                return p.name == permission;
            });
        },
        saveDescription(description_id)
        {
            var that = this;
            axios.post('/save-description/'+description_id,{
                scientific_description: that.scientific_description,
                description_id: description_id
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    this.$toast.open(response.data.message);
                }
            });
        },
        populateData()
        {
            this.id=this.$props.item.id;
            this.cipher=this.$props.item.cipher;
            this.item_number=this.$props.item.item_number;
            this.item_subnumber=this.$props.item.item_subnumber;
            this.photo_number=this.$props.item.photo_number;
            this.acquire_from=this.$props.item.acquire_from;
            this.author=this.$props.item.author;
            this.item_copyright_id=this.$props.item.item_copyright_id;
            this.location_of_manufacture=this.$props.item.location_of_manufacture;
            this.time_of_manufacture=this.$props.item.time_of_manufacture;
            this.content_date=this.$props.item.content_date;
            this.old_description=this.$props.item.old_description;
            this.description=this.$props.item.description;
            this.item_heading=this.$props.item.item_heading;
            this.notes=this.$props.item.notes;
            this.placement=this.$props.item.placement;
            this.size=this.$props.item.size;
            this.material=this.$props.item.material;
            this.price_eur=this.$props.item.price_eur;
            this.price_ls=this.$props.item.price_ls;
            this.item_count=this.$props.item.item_count;
            this.entry_date=this.$props.item.entry_date;
            this.entry_time=this.$props.item.entry_time;
            // this.act_number=this.$props.item.act_number;
            this.act_id=this.$props.item.act_id;
            this.post_processing=this.$props.item.post_processing;
            this.purchase=this.$props.item.purchase;
            this.date_of_migration_to_nmkk=this.$props.item.date_of_migration_to_nmkk;
            this.item_value=this.$props.item.item_value;
            this.evaluation_report=this.$props.item.evaluation_report;
            this.existence=this.$props.item.existence;
            this.acquire_type_id=this.$props.item.acquire_type_id;
            this.collection_id=this.$props.item.collection_id;
            this.title_id=this.$props.item.title_id;
            this.act_number = this.$props.item.act && this.$props.item.act.act_number;

            this.item_images = this.$props.item.images;
            this.item_files = this.$props.item.files;
            this.scientific_description = this.$props.item.scientific_description;
            this.item_events = this.$props.item.events;

            if(this.$props.item.collection)
            {
                this.item_collection=this.$props.item.collection.title;
            }
            else
            {
                this.item_collection = "Nav norādīta";
            }
            if(this.$props.item.title) {
                this.item_title = this.$props.item.title.title;
            }
            else
            {
                this.item_title = "Nav norādīts";
            }

            if(this.$props.item.transfer_type) {
                this.transfer_type = this.$props.item.transfer_type.collection_title;
            }
            else
            {
                this.transfer_type = "Nav norādīts";
            }

            if(this.$props.item.scientific_theme) {
                this.scientific_theme = this.$props.item.scientific_theme.title;
            }
            else
            {
                this.scientific_theme = "Nav norādīts";
            }
        },
        openNextItemModal()
        {
            EventBus.$emit('open_next_item_view_modal', this.id);
        },
        openPrevItemModal()
        {
            EventBus.$emit('open_prev_item_view_modal', this.id);
        },
        createNewDescription()
        {
            var that = this;
            axios.post('/item/'+this.id+'/create-description',
                {
                    scientific_description: that.scientific_description
                }).then(response =>{
                that.scientific_description = response.data.item.scientific_description;
            });
        },
        deleteDescription(id)
        {
            var that = this;
            axios.post('/item/'+this.id+'/delete-description/'+id,
                {
                    scientific_description: that.scientific_description
                }).then(response =>{
                that.scientific_description = response.data.item.scientific_description;
            });
        },
        changeStep(name){
            this.step = name;
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
    },

    computed: {
        events_list()
        {
            if(this.item_events)
            {
                return this.item_events.map(function(event)
                {
                    return {
                        id: event.id,
                        item_id: event.item_id,
                        start_date: moment(event.start_date, moment.ISO_8601)._d,
                        end_date: moment(event.end_date, moment.ISO_8601)._d,
                        event_name: event.event_name,
                        event_description: event.event_description,
                        event_type: event.event_type,
                        user: event.user,
                    }
                });
            }
            else {
                return null;
            }
        },
        imageListForLightbox()
        {
            if(this.item_images)
            {
                return this.item_images.map(function(image)
                {
                    return {
                        src:'/image/'+image.file_name,
                        //src:'/storage/items/'+image.item_id+'/images/generated/original/'+image.file_name,
                        description:image.original_file_name,
                    }
                });
            }
            else
            {
                return [];
            }

        },
        dragOptions() {
            return {
                animation: 200,
                // group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
    },


}
</script>
